<template>
  <v-content style="background: #eee; padding-top: 50px" app>
    <v-breadcrumbs class="pl-4" divider=">" :items="breadcrumbList" />

    <v-fade-transition mode="out-in">
      <v-layout>
        <v-flex xs12 xl8 offset-xl2>
          <router-view />
        </v-flex>
      </v-layout>
    </v-fade-transition>

    <modal-close />
  </v-content>
</template>

<script>
import { mapState } from 'vuex';

import ModalClose from './ModalClose';

export default {
  components: {
    ModalClose
  },
  computed: {
    ...mapState({
      breadcrumbList: state => state.breadcrumbs.breadcrumbs
    })
  }
};
</script>
